<div class="dialog-content">
    <div mat-dialog-title class="dialog-title">
        <span>Two-Factor Authentication Required</span>
    </div>
    <div class="underline"></div>
    <div mat-dialog-content class="dialog-text">{{data}}</div>
    <div mat-dialog-actions>
        <button mat-raised-button color="warn" (click)="confirmedOption()">Enable MFA</button>
        <button mat-raised-button class="dialog-btn" (click)="canceledOption()">Log Out</button>
    </div>
</div>
